module.exports = __webpack_public_path__ + "img/302.4c70d5d2.svg";